module.exports = __webpack_public_path__ + "images/clesyclean-logo-claim.41a99da232222909074d63f8e31eaef6.png";